import * as apiRoutes from '../../apiRoutes';
import { actionTypes } from "../../actionTypes";
import { APIUrl } from "../../constants";
import * as api from '../../tools/apiMiddleware';

const initialState = {
    data: {}, isLoading: true, canReturnBack: false, canEdit: false, visible: false, broadcasterId: 0
};

export const nonLinearFormStore = {
    getMode: (programmeId) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.Mode + `/${programmeId}`;
        await api.getRequest(dispatch, url, actionTypes.GET_MODE, actionTypes.GET_MODE_SUCCESS, actionTypes.GET_MODE_FAIL);

    },
    clearErrorMessage: () => (dispatch, getState) => {

        dispatch({ type: actionTypes.MODE_CLEAR_ERROR });

    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.GET_MODE:
            return {
                ...state,
                data: state.data,
                isLoading: true,
                hasErrorOccured: false
            };
        case actionTypes.GET_MODE_SUCCESS:
            return {
                ...state,
                data: action.data,
                canEdit: action.data.canEdit,
                visible: action.data.visible,
                broadcasterId: action.data.broadcasterId,
                isLoading: false,
                hasErrorOccured: false
            };
        case actionTypes.GET_MODE_FAIL:
            return {
                ...state,
                isLoading: false,
                data: state.data,
                hasErrorOccured: true,
                errorData: action.data
            };
        case actionTypes.MODE_CLEAR_ERROR:
            return {
                ...state,
                hasErrorOccured: false
            };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/store/NonLinear/NonLinearFormStore.js